import { getBackendUrl } from '../utils/utils';

export interface Notification {
    id: string;
    user_id: string;
    type: string;
    message: string;
    created_at: string;
    read: boolean;
    read_at: string | null;
    link: string | null;
}

export interface NotificationListResponse {
    items: Notification[];
    total: number;
    page: number;
    page_size: number;
}

export const fetchNotifications = async (
    token: string,
    page = 1,
    pageSize = 20,
    unreadOnly = false
): Promise<NotificationListResponse> => {
    const backendUrl = getBackendUrl();
    const params = new URLSearchParams({
        page: String(page),
        page_size: String(pageSize),
        unread_only: String(unreadOnly),
    });
    const response = await fetch(`${backendUrl}/notifications?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to fetch notifications');
    return response.json();
};

export const fetchUnreadCount = async (token: string): Promise<number> => {
    const backendUrl = getBackendUrl();
    const response = await fetch(`${backendUrl}/notifications/unread-count`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to fetch unread count');
    const data = await response.json();
    return data.count;
};

export const markNotificationRead = async (
    token: string,
    notificationId: string
): Promise<Notification> => {
    const backendUrl = getBackendUrl();
    const response = await fetch(`${backendUrl}/notifications/mark-read/${notificationId}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to mark notification as read');
    return response.json();
};

export const markAllNotificationsRead = async (token: string): Promise<number> => {
    const backendUrl = getBackendUrl();
    const response = await fetch(`${backendUrl}/notifications/mark-all-read`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to mark all notifications as read');
    const data = await response.json();
    return data.marked_count;
};
